/**
 * Compare Tab Sync
 * Keeps SOAP tab selections synchronized between past/current columns.
 * When a tab is activated in one column, the matching tab in the other column
 * is also activated.
 */
var CompareTabSync = (function() {
  'use strict';

  var initialized = false;
  var syncing = false;
  var _onTabShownRef = null;

  function findMatchingTabInOtherColumn(trigger) {
    var tabName = trigger.getAttribute('data-sync-tab-name');
    if (!tabName) return null;

    var group = trigger.closest('[data-sync-tab-group]');
    if (!group) return null;

    // Find the other column's tab group
    var allGroups = document.querySelectorAll('[data-sync-tab-group="' + group.getAttribute('data-sync-tab-group') + '"]');
    var otherGroup = null;
    for (var i = 0; i < allGroups.length; i++) {
      if (allGroups[i] !== group) {
        otherGroup = allGroups[i];
        break;
      }
    }
    if (!otherGroup) return null;

    // Find the tab with the same sync-tab-name in the other group
    var tabs = otherGroup.querySelectorAll('[data-sync-tab-name]');
    for (var j = 0; j < tabs.length; j++) {
      if (tabs[j].getAttribute('data-sync-tab-name') === tabName) {
        return tabs[j];
      }
    }
    return null;
  }

  function onTabShown(e) {
    if (syncing) return;

    var trigger = e.detail && e.detail.trigger;
    if (!trigger) return;

    var group = trigger.closest('[data-sync-tab-group]');
    if (!group) return;

    var matchingTab = findMatchingTabInOtherColumn(trigger);
    if (!matchingTab) return;

    syncing = true;
    try {
      if (window.TabManager && typeof window.TabManager.activateTab === 'function') {
        window.TabManager.activateTab(matchingTab);
      } else {
        matchingTab.click();
      }
    } finally {
      syncing = false;
    }
  }

  function init() {
    if (initialized) return;
    initialized = true;

    _onTabShownRef = onTabShown;
    document.addEventListener('tab:shown', _onTabShownRef);
  }

  function reset() {
    if (_onTabShownRef) {
      document.removeEventListener('tab:shown', _onTabShownRef);
      _onTabShownRef = null;
    }
    initialized = false;
  }

  return { init: init, reset: reset };
})();

document.addEventListener('turbolinks:load', function() {
  CompareTabSync.init();
});
document.addEventListener('turbo:load', function() {
  CompareTabSync.init();
});
document.addEventListener('turbo:before-cache', function() {
  CompareTabSync.reset();
});

if (document.readyState !== 'loading') {
  CompareTabSync.init();
}

window.CompareTabSync = CompareTabSync;
